import AttachmentsPreview from '@sdk/attachments/components/AttachmentsPreview/AttachmentsPreview';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext from '@sdk/lang/gettext';
import { useToggle } from '@sdk/common/hooks/useToggle';

import {
  BackButton,
  BackIcon,
} from '@web/newsfeed/ArticleSearch/ArticleSearchDetails/articleSearchDetails.styles';
import { ArticleHeader } from '@web/newsfeed/Article/ArticleHeader/ArticleHeader';
import { MarkdownDisplayWrapper } from '@web/components/MarkdownDisplayWrapper';
import { ArticleFooter } from '@web/newsfeed/Article/ArticleFooter/ArticleFooter';
import { ArticleComments } from '@web/newsfeed/Article/ArticleComments/ArticleComments';
import { useArticleSearchActions } from '@web/newsfeed/ArticleSearch/hooks/useArticleSearchActions';
import { useArticleSearchDetails } from '@web/newsfeed/ArticleSearch/ArticleSearchDetails/articleSearchDetails.hooks';
import { ArticleSearchSkeleton } from '@web/newsfeed/ArticleSearch/ArticleSearchSkeleton/ArticleSearchSkeleton';
import { ArticleBox, ArticleWrapper } from '@web/newsfeed/Article/article.styles';

export const ArticleSearchDetails = () => {
  const { isOn: areCommentsVisible, toggle: toggleComments } = useToggle();
  const { toggleLike } = useArticleSearchActions();
  const { article, parsedContent, backToSearch } = useArticleSearchDetails();

  return (
    <>
      {article ? (
        <ArticleBox>
          <ArticleWrapper>
            <ArticleHeader article={article}></ArticleHeader>
            <MarkdownDisplayWrapper dangerouslySetInnerHTML={parsedContent} />
            <div>
              {!!article.attachments?.length && (
                <AttachmentsPreview attachments={article.attachments} />
              )}
              <ArticleFooter
                article={article}
                toggleComments={toggleComments}
                onLikeClick={() => toggleLike(article)}
              />
            </div>
          </ArticleWrapper>
          {areCommentsVisible && <ArticleComments article={article} />}
        </ArticleBox>
      ) : (
        <ArticleSearchSkeleton />
      )}

      <BackButton onClick={backToSearch}>
        <BackIcon />
        <Text14 themeColor={ThemeColorType.gray} semiBold>
          {gettext('Back to search results')}
        </Text14>
      </BackButton>
    </>
  );
};
